// extracted by mini-css-extract-plugin
export default {"container":"TextLink_container__horTJ","disabled":"TextLink_disabled__ZTNvi","container__children":"TextLink_container__children__+S2wS","noIcon":"TextLink_noIcon__A-LPh"};